export default __webpack_public_path__ + "static/media/certificate-invalid.a9ac96af.svg";